import styles from './styles.module.scss';

export const Avatar = ({ type, data }) => {
  // Verificar se data.avatar existe antes de desestruturar
  if (!data?.avatar) {
    return null;
  }

  // Verificar se images existe e tem pelo menos um elemento
  if (
    !data.avatar.images ||
    !Array.isArray(data.avatar.images) ||
    data.avatar.images.length === 0
  ) {
    return null;
  }

  const {
    images: [i],
    avatarsize,
    routeradius,
  } = data.avatar;

  return (
    <div className={styles.container}>
      <img
        src={i}
        alt="Foto de perfil"
        style={{
          width: avatarsize + 'px',
          height: avatarsize + 'px',
          borderRadius:
            routeradius === 'round'
              ? '100%'
              : routeradius === 'rounded'
              ? '20%'
              : 0,
        }}
      />
    </div>
  );
};
